// Shared types for question components that work with both forms and surveys

export interface Answer {
  id: string | number;
  answer: string;
  order?: number;
  _destroy?: boolean;
}

export interface BaseQuestion {
  id: string;
  name: string;
  label: string;
  answerStyle: string;
  required: boolean;
  helpText?: string;
  description?: string;
  moreInfo?: string;
  showComments?: boolean;
  showAnswerOptions?: boolean;
  allowMultipleAnswers?: boolean;
  answererCanUploadFiles?: boolean;
  answers?: Answer[];
  options?: {
    displayType?: string;
    useCharacterLimit?: boolean | string;
    characterLimit?: number;
    largeComments?: boolean;
    // Tag question options
    show_tag_question?: string | boolean;
    showTagQuestion?: boolean;
    seeking_tags?: string | boolean;
    seekingTags?: boolean;
    tags_filter_selected?: string;
    tagsFilterSelected?: string;
    request_tags?: string;
    requestTags?: string;
    qualifications_title?: string;
    qualificationsTitle?: string;
    open_ended_qualification_question?: string;
    openEndedQualificationQuestion?: string;
    ask_open_ended_qualification_question?: string | boolean;
    askOpenEndedQualificationQuestion?: boolean;
    [key: string]: any;
  };
  qualifications?: Array<{
    id: string;
    name: string;
  }>;
}

// Helper to check if we should show answer options
// For surveys, we always show if there are answers
// For forms, we check the showAnswerOptions flag
export function shouldShowAnswerOptions(question: BaseQuestion): boolean {
  if (question.showAnswerOptions !== undefined) {
    return question.showAnswerOptions;
  }
  // For surveys, show if there are answers
  return !!(question.answers && question.answers.length > 0);
}